import { apiClient } from "@/shared/api/client"
import { scenarioPath } from "./keys"
import type { ScenarioDraft, ScenarioListItem } from "./types"

export const listScenarios = async () =>
	(await apiClient.get<ScenarioListItem[]>("/admin/bot-scenarios")).data

export const getScenario = async (id: string) =>
	(await apiClient.get<ScenarioDraft>(scenarioPath(id))).data

export const createScenario = async (body: { name: string; description?: string }) =>
	(await apiClient.post<ScenarioDraft>("/admin/bot-scenarios", body)).data

export const updateScenario = async (
	id: string,
	body: { name?: string; description?: string | null },
) => (await apiClient.patch<ScenarioDraft>(scenarioPath(id), body)).data

export const deleteScenario = async (id: string) => {
	await apiClient.delete(scenarioPath(id))
}
